export const UFE_SAVE_CHANGED_COMMON_SETTINGS = 'UFE_SAVE_CHANGED_COMMON_SETTINGS';

export const saveChangedSettings = (settings) => ({
    type: UFE_SAVE_CHANGED_COMMON_SETTINGS,
    payload: { ...settings },
});
